<template>
  <div class="recordsGrid">
    <h4>{{ $t('records.grid.header') }}</h4>
    <p>{{ $t('records.grid.subtitle') }}</p>
    <records-table v-loading="loading" />
  </div>
</template>

<script>
import RecordsTable from '@/components/records/RecordsTable'

export default {
  name: "RecordsGrid",
  components: {
    RecordsTable
  },
  data: () => ({
    loading: false
  }),
  async mounted() {
    this.loading = true
    try {
      await this.$store.dispatch('records/getRecords')
    } catch (error) {
      console.warn(error)
    }
    this.loading = false
  }
}
</script>

<style lang="scss" scoped>
$c: '.recordsGrid';

#{$c} {
  &__record {
    cursor: pointer;

    &:hover {
      color: $--color-primary;
      font-weight: 600;
    }
  }
}
</style>